export type LogLevel = 'none' | 'error' | 'warn' | 'log' | 'info' | 'debug';

export type Logger = Pick<Console, 'debug' | 'info' | 'log' | 'warn' | 'error'>;

/**
 * Возвращает logger. В МФ достаточно console: шаблонный main.ts не инициализирует отдельный инстанс.
 */
export const useLogger = (): Logger => console;
